export {};
//# sourceMappingURL=IPageViewPerformanceTelemetry.js.map